/** The GitHub frame: pull requests, checks, commits and the branch picker. */
export default {
  // Frame
  more: "More",
  discardBranch: "Discard branch",
  discardBranchTitle: "Discard branch?",
  discardBranchDescription: "Moves the task back to Backlog. The branch stays.",
  discard: "Discard",
  discardFailed: "Failed to discard branch",
  unknownError: "Unknown error",
  emptyState: "No pull requests, checks or commits yet",
  cardEmpty: "No pull requests or commits yet",

  // Sections
  pullRequests: { one: "Pull request", other: "Pull requests" },
  intoBase: "#{number} into {base}",
  checksFailedCount: "{failed} of {total} checks failed",
  checksRunningCount: "{running} of {total} checks running",
  checksPassedCount: "{passed} of {total} checks passed",
  checksFailed: "Checks failed",
  checksRunning: "Checks running",
  checks: "Checks",
  runPassed: "Passed",
  runFailed: "Failed",
  runRunning: "Running",
  runQueued: "Queued",
  runCancelled: "Cancelled",
  runSkipped: "Skipped",
  runAfter: "{status} after {duration}",
  commits: "Commits",
  showMore: "Show {count} more",

  // Branch picker
  selectBranch: "Select branch",
  filterBranchesPlaceholder: "Filter branches…",
  filterBranches: "Filter branches",
  current: "Current",
  noMatch: "No match",
  activeCoderBranches: "Active coder branches",
  defaultBranch: "Default branch",
  allBranches: "All branches",
  loadingBranches: "Loading branches…",
  noRepoLinked: "No repo linked — set a working directory in project settings.",
  loadBranchesFailed: "Failed to load branches ({reason})",
  network: "network",
  noOtherBranches: "No other branches yet.",
} as const;
